import { useState, useContext, useEffect } from "react";
import { branchSwitchContext } from "../../contexts/BranchSwitchProvider";
import socket from "../../socket/socket";

const Order = ({ setModal, Layout, fetchOrders, hideMap, setHideMap, height }) => {
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const { branchSwitch } = useContext(branchSwitchContext);

  const fetchData = async () => {
    const response = await fetchOrders(1, 5);
    const newOrders = response.data.data;
    setTotal(response?.data?.total);
    setOrders(newOrders);
    setHasMore(newOrders.length > 0);
    setPage(2);
  };

  const fetchMoreData = async () => {
    const response = await fetchOrders(page, 5);
    const newOrders = response.data.data;

    setOrders((prev) => [...prev, ...newOrders]);
    setHasMore(newOrders.length > 0);

    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [branchSwitch]);
  useEffect(() => {
    socket.on(`merchant:ordersUpdate`, (data) => {
      if (data) {
        fetchData();
      }
    });
    return () => {
      socket.off(`merchant:ordersUpdate`);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Layout
      setModal={setModal}
      orders={orders}
      total={total}
      hasMore={hasMore}
      fetchMoreData={fetchMoreData}
      fetchData={fetchData}
      hideMap={hideMap}
      setHideMap={setHideMap}
      height={height}
    />
  );
};

export default Order;
